import { Redirect, useLocalSearchParams } from "expo-router";

export default function TenantIndexScreen() {
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();

  return <Redirect href={`/tenants/${tenantId}/overview` as never} />;
}
